<div class="container">
    <div class="text-center m-5">
        <h1>CrossOver Analisi</h1>
    </div>
    <div style="height: 500px; overflow-y: scroll;">
        <div class="datatable mt-4">
            <table class="table datatable-table" mdbTable mdbTableSort #table="mdbTable" #sort="mdbTableSort"
                [dataSource]="tableData" [sort]="sort">
                <thead class="datatable-header">
                    <tr>
                        <th *ngFor="let header of headers" [mdbTableSortHeader]="header" scope="col">
                            {{ header | titlecase }}
                        </th>
                    </tr>
                </thead>
                <tbody class="datatable-body">

                    <tr *ngFor="let data of table.data" scope="row">
                        <td><button class="btn-primary" (click)="openChart(data.market)">{{data.market}}</button></td>
                        <td>{{data.profit | number:'1.4-4'}}</td>
                        <td class="justify-content-end">{{data.profiteuro | number:'1.2-2'}}</td>
                        <td>{{data.numop}}</td>
                        <td>{{data.profit_op | number:'1.4-5'}}</td>
                        <td class=" justify-content-end">{{100*data.numpos/data.numop | number:'1.2-2'}} %</td>
                        <td class=" justify-content-end">{{data.sommapos/data.numpos | number: '1.4-4'}}</td>
                        <td class=" justify-content-end">{{(data.profit-data.sommapos)/(data.numop-data.numpos) | number: '1.4-4'}}</td>
                        <td class=" justify-content-end">{{-(data.sommapos/data.numpos)/((data.profit-data.sommapos)/(data.numop-data.numpos)) | number: '1.2-2'}}</td>
                        <td class=" justify-content-end">{{data.maxdd | number:'1.4-4'}}</td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12">
            <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"
                [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngularFlag"
                style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
    </div>
</div>